import * as ACTIONS_TYPE from '../actions/actionsTypes';
import * as GLOBALES from '../../utils/globales';
import * as Constantes from "../../utils/constantes";
import * as Funciones from '../../utils/funciones'

export const initialState = {
    users: [],
    photos: {
        asegurado: {
            frontal: '',
            posterior: ''
        },
        contratante: {
            frontal: '',
            posterior: ''
        }
    },
    photosAdicional: {
        asegurado: {
            frontal: '',
            posterior: ''
        },
        contratante: {
            frontal: '',
            posterior: ''
        }
    },
    estadoCargando: false,
    tiempoSesion: Constantes.TIEMPO_SESION * 60,
    error: null,
    bloquearFlujo: false
    //tablasMaestras: null
}

export const GeneralReducer = (state, action) => {
    let users;
    let user;
    let listaProspectos;
    let prospecto;
    let photos;
    let photosAdicional;

    switch (action.type) {
        case ACTIONS_TYPE.UPDATE_ERROR: {
            let error = null
            if (action.payload.error !== null) {
                error = {
                    ...action.payload.error,
                    titulo: action.payload.titulo,
                    labelAccion: action.payload.labelAccion,
                    accion: action.payload.accion,
                    labelCancelar: action.payload.labelCancelar,
                    cancelar: action.payload.cancelar
                }
            }
            return {
                ...state,
                error: error,
                estadoCargando: action.payload.error !== null ? false : state.estadoCargando,
                bloquearFlujo: action.payload.bloquearFlujo !== undefined && action.payload.bloquearFlujo !== null
                    ? action.payload.bloquearFlujo : state.bloquearFlujo
            }
        }

        case ACTIONS_TYPE.UPDATE_ESTADO_CARGANDO: {
            return {
                ...state,
                estadoCargando: action.payload.estadoCargando,
                tiempoSesion: Constantes.TIEMPO_SESION * 60
            }
        }

        case ACTIONS_TYPE.UPDATE_TIEMPO_SESION : {
            return {
                ...state,
                tiempoSesion: action.payload.tiempoSesion
            }
        }

        case ACTIONS_TYPE.SET_DATOS_USUARIO: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null

            if (users !== null) {
                let userEncontrado = false
                users.map(userAux => {
                    if (userAux.info !== null && userAux.info !== undefined &&
                        userAux.info.CodigoIntermediario === action.payload.usuario.info.CodigoIntermediario) {
                            userAux.token = action.payload.usuario.token
                            userAux.roles = action.payload.usuario.roles
                            userAux.info = action.payload.usuario.info
                            userAux.isAuthenticated = true
                            userEncontrado = true
                    } else {
                        userAux.isAuthenticated = false
                    }
                    return userAux
                })

                if (!userEncontrado) {
                    user = {
                        ...action.payload.usuario,
                        isAuthenticated: true
                    }
                    users = [
                        ...users,
                        user
                    ]
                }
            } else {
                user = {
                    ...action.payload.usuario,
                    isAuthenticated: true
                }
                users = [
                    user
                ]
            }

            localStorage.setItem("usersSD", JSON.stringify(users))
            localStorage.setItem("access.token", action.payload.usuario.token.access_token)
            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.GET_USUARIO: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null

            if (users) {
                users.map(userAux => {
                    if (userAux.info !== null && userAux.info !== undefined &&
                        userAux.info.IdUsuario === action.payload.IdUsuario) {
                        userAux.isAuthenticated = true
                    } else {
                        userAux.isAuthenticated = false
                    }
                    return userAux
                })
            }

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.LOGIN: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null

            if (users !== null) {
                let userEncontrado = false
                users.map(userAux => {
                    if (userAux.info !== null && userAux.info !== undefined &&
                        userAux.info.CodigoIntermediario === action.payload.user.info.CodigoIntermediario) {
                        userAux.info = action.payload.user.info
                        userAux.isAuthenticated = true
                        userAux.token = {
                            ...action.payload.user.token,
                            new_token: 0
                        }

                        userEncontrado = true
                    } else {
                        userAux.isAuthenticated = false
                    }
                    return userAux
                })

                if (!userEncontrado) {
                    user = {
                        info: action.payload.user.info,
                        isAuthenticated: true,
                        token: {
                            ...action.payload.user.token,
                            new_token: 0
                        },
                        data: action.payload.user.data
                    }
                    users = [
                        ...users,
                        user
                    ]
                }
            } else {
                user = {
                    info: action.payload.user.info,
                    isAuthenticated: true,
                    token: {
                        ...action.payload.user.token,
                        new_token: 0
                    },
                    data: action.payload.user.data
                }
                users = [
                    user
                ]
            }

            localStorage.setItem("usersSD", JSON.stringify(users))
            //Tablas Maestras
            let tablasMaestras = localStorage.getItem('tablasMaestrasSD') !== undefined
                ? JSON.parse(localStorage.getItem('tablasMaestrasSD') || null)
                : null
            localStorage.setItem('tablasMaestrasSD', JSON.stringify(tablasMaestras))

            //Parametros
            let parametros = localStorage.getItem('parametrosSD') !== undefined
                ? JSON.parse(localStorage.getItem('parametrosSD') || null)
                : null
            localStorage.setItem('parametrosSD', JSON.stringify(parametros))

            return {
                ...state,
                users,
                tablasMaestras,
                parametros
            }
        }

        case ACTIONS_TYPE.LOGOUT: {
            users = state.users.map(user => {
                user = {
                    ...user,
                    isAuthenticated: false,
                    token: null,
                    roles: null
                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.UPDATE_TOKEN: {
            let newToken = action.payload.token
            users = state.users.map(user => {
                user = {
                    ...user,
                    token: {
                        ...user.token,
                        access_token: newToken,
                        new_token: (user.token.new_token + 1)
                    }
                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))
            localStorage.setItem("access.token", newToken)

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.SET_LISTA_PROSPECTOS: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users = users && users.map(user => {
                if (user.isAuthenticated) {
                    listaProspectos = action.payload.listaProspectos && action.payload.listaProspectos.map(prospecto => {
                        let prospectoStg = user && user.listaProspectos
                            ? user.listaProspectos.filter(prospectoAux => prospecto.idProspecto === prospectoAux.idProspecto)[0]
                            : null
                        if (prospectoStg) {
                            prospecto = prospectoStg
                        }
                        if (prospecto.completado) {
                            prospecto.listaMenu = null
                            prospecto.completado = false
                        }
                        return prospecto
                    })
                }
                user.listaProspectos = listaProspectos
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.SET_DATA_PROSPECTO: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users = users && users.map(user => {
                if (user.isAuthenticated) {
                    let prospecto = action.payload.prospecto
                    listaProspectos = []
                    if (user && user.listaProspectos) {
                        listaProspectos = user.listaProspectos
                        let existeProspecto = false
                        listaProspectos.map(prospectoAux => {
                            if (prospectoAux.idProspecto === prospecto.idProspecto) {
                                existeProspecto = true
                                prospectoAux.isSelected = true
                                prospectoAux.cotizaciones = null
                            } else {
                                prospectoAux.isSelected = false
                            }
                            return prospectoAux
                        })
                        if (!existeProspecto) {
                            listaProspectos.push({
                                ...prospecto,
                                listaMenu: null,
                                completado: false,
                                isSelected: true
                            })
                        }
                    } else {
                        listaProspectos.push({
                            ...prospecto,
                            listaMenu: null,
                            completado: false,
                            isSelected: true
                        })
                    }
                }
                user.listaProspectos = listaProspectos
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.CONTINUAR_PROCESO: {
            users = state.users.map(user => {
                if (user.isAuthenticated) {
                    prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
                    prospecto.cotizaciones.map(cotizacion => {
                        if (cotizacion.isSelected) {
                            cotizacion.inicioFlujo = false
                            if (cotizacion.listaMenu !== undefined) {
                                cotizacion.listaMenu.map((menu, indexMenu) => {
                                    if (menu.url === action.payload.url) {
                                        menu.completado = true
                                        menu.paginaActual = false

                                        if (cotizacion.listaMenu[indexMenu + 1] !== undefined &&
                                            cotizacion.listaMenu[indexMenu + 1].listaSubmenu !== undefined &&
                                            cotizacion.listaMenu[indexMenu + 1].listaSubmenu !== null &&
                                            cotizacion.listaMenu[indexMenu + 1].listaSubmenu.length > 0) {
                                            cotizacion.listaMenu[indexMenu + 1].listaSubmenu[0].paginaActual = true
                                        }

                                        if (cotizacion.listaMenu.length === indexMenu + 1) {
                                            console.info('PROCESO TERMINADO')
                                        } else {
                                            cotizacion.listaMenu[indexMenu + 1].paginaActual = true
                                        }
                                    } else {
                                        if (menu.listaSubmenu !== undefined && menu.listaSubmenu !== null && menu.listaSubmenu.length > 0) {
                                            menu.listaSubmenu.map((submenu, indexSubMenu) => {
                                                if (submenu.url === action.payload.url) {
                                                    submenu.completado = true
                                                    submenu.paginaActual = false

                                                    if (menu.listaSubmenu.length === indexSubMenu + 1) {
                                                        menu.completado = true
                                                        menu.paginaActual = false
                                                        cotizacion.listaMenu[indexMenu + 1].paginaActual = true
                                                        if (cotizacion.listaMenu !== undefined &&
                                                            cotizacion.listaMenu[indexMenu + 1] !== undefined &&
                                                            cotizacion.listaMenu[indexMenu + 1].listaSubmenu !== undefined &&
                                                            cotizacion.listaMenu[indexMenu + 1].listaSubmenu != null &&
                                                            cotizacion.listaMenu[indexMenu + 1].listaSubmenu.length > 0) {
                                                            cotizacion.listaMenu[indexMenu + 1].listaSubmenu[0].paginaActual = true
                                                        }
                                                    } else {
                                                        menu.listaSubmenu[indexSubMenu + 1].paginaActual = true
                                                    }
                                                }

                                                return submenu
                                            })
                                        }
                                    }

                                    return menu
                                })
                            }
                        }
                        return cotizacion
                    })
                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.LIMPIAR_DATA_PROCESO: {
            users = state.users.map(user => {
                if (user.isAuthenticated) {
                    prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
                    prospecto.cotizaciones.map(cotizacion => {
                        if (cotizacion.isSelected) {
                            cotizacion.inicioFlujo = false
                            if (cotizacion.listaMenu !== undefined) {
                                cotizacion.listaMenu.map(menu => {
                                    if (menu.completado || menu.paginaActual) {
                                        menu.completado = false
                                        menu.paginaActual = false
                                    }
                                    if (menu.listaSubmenu !== undefined && menu.listaSubmenu !== null && menu.listaSubmenu.length > 0) {
                                        menu.listaSubmenu.map(submenu => {
                                            if (submenu.completado || submenu.paginaActual) {
                                                submenu.completado = false
                                                submenu.paginaActual = false
                                            }
                                            return submenu
                                        })
                                    }
                                    return menu
                                })
                            }
                        }
                        return cotizacion
                    })
                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.UPDATE_DATA_PROSPECTO: {
            users = state.users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.inicioFlujo = false
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })
                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.FINALIZAR_PROSPECTO: {
            users = state.users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.isSelected = false
                                    cotizacion.completado = true
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })
                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.DELETE_OPCION_MENU: {
            users = state.users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.listaMenu = cotizacion.listaMenu.filter(menu => {
                                        if (menu.listaSubmenu !== undefined && menu.listaSubmenu !== null &&
                                            menu.listaSubmenu.length > 0) {
                                            menu.listaSubmenu = menu.listaSubmenu.filter(submenu =>
                                                submenu.url !== action.payload.url)
                                        }
                                        return menu.url !== action.payload.url
                                    })
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })
                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.SET_SOLICITUD_PROSPECTO: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.idSolicitudMultiple = action.payload.idSolicitudMultiple
                                    cotizacion.solicitudes = action.payload.solicitudes
                                    cotizacion.flagDeclaJurada = action.payload.flagDeclaracion

                                    //Agregando Productos
                                    let productos = cotizacion.productos.map(producto => {
                                        let productoAux = action.payload.productos.filter(productoL => productoL.codigoProducto === producto.codigoProducto)[0]
                                        producto.codigoLineaNegocio = productoAux.codigoLineaNegocio
                                        return producto
                                    })
                                    cotizacion.productos = productos

                                    //Agregando detallesTraspasoReemplazo
                                    let tieneReemplazo = action.payload.solicitudes.filter(sol => sol.flagReemplazoTraspaso !== 0)
                                    if (tieneReemplazo.length !== 0) {
                                        let detalles = tieneReemplazo.map(reemplazo => {
                                            let nombresO = reemplazo.nombreProductoPolizaOrigen.split(',')
                                            let numerosO = reemplazo.numeroPolizaOrigen.split(',')
                                            let pol = nombresO.map((nom, index) => {
                                                return {
                                                    label: numerosO[index] + ' - ' + nom,
                                                    value: parseInt(numerosO[index])
                                                }
                                            })
                                            let tipoProducto = productos.find(p => p.codigoProducto === reemplazo.codigoProducto).codigoTipoProducto
                                            
                                            return {
                                                flagReemplazoTraspaso: reemplazo.flagReemplazoTraspaso,
                                                idSolicitud: reemplazo.idSolicitud,
                                                polizas: pol,
                                                tipoProd: tipoProducto,
                                                tipoTraspaso: reemplazo.codigoTipoTraspaso
                                            }
                                        })
                                        cotizacion.listaDetalleReemplazo = detalles
                                        cotizacion.listaDetalleReemplazoAdicional = detalles
                                    }
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.SET_ASEGURADO_PROSPECTO: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => { console.log("prospecto", prospecto)
                                if (cotizacion.isSelected) {
                                    let asegurado = {
                                        ...action.payload.asegurado,
                                    }
                                    cotizacion.asegurado = asegurado
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })
                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.SET_ASEGURADO_ADICIONAL_PROSPECTO: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    let aseguradoAdicional = {
                                        ...action.payload.aseguradoAdicional,
                                        adjuntos: action.payload.aseguradoAdicional.adjuntos.map(adjunto => {
                                            let adjuntoAux = {
                                                cargado: adjunto.cargado,
                                                descripcion: adjunto.descripcion
                                            }
                                            return adjuntoAux
                                        })
                                    }
                                    cotizacion.aseguradoAdicional = aseguradoAdicional
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })
                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.UPDATE_LPDP_PROSPECTO: {
            users = state.users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.lpdp = action.payload.flag
                                    cotizacion.lpdpAdicional = action.payload.flagAdicional
                                    cotizacion.codigoEstado = action.payload.codigo
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })
                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.UPDATE_ASEGURADO_PROSPECTO: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.preguntas = action.payload.preguntas
                                    cotizacion.subpreguntas = action.payload.subpreguntas !== null ? action.payload.subpreguntas : cotizacion.subpreguntas
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.UPDATE_ASEGURADO_ADICIONAL_PROSPECTO: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.preguntasAdicional = action.payload.preguntasAdicional
                                    cotizacion.subpreguntasAdicional = action.payload.subpreguntasAdicional !== null ? action.payload.subpreguntasAdicional : cotizacion.subpreguntasAdicional
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.UPDATE_ESTADO_PROSPECTO: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.edicionInhabilitada = true
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.UPDATE_ESTADO_FIRMA: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.firmaValidada = true
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.UPDATE_INFORMATION_PHOTO: {
            const { image, type, identification } = action.payload
            // Le asigno a la variable photos el state actual de photos
            photos = state.photos
            // Ingreso a la propiedad del objeto según su variable
            photos[identification][type] = image

            return {
                ...state,
                photos
            }
        }

        case ACTIONS_TYPE.UPDATE_INFORMATION_PHOTO_ADICIONAL: {
            const { image, type, identification } = action.payload
            // Le asigno a la variable photos el state actual de photos
            photosAdicional = state.photosAdicional
            // Ingreso a la propiedad del objeto según su variable
            photosAdicional[identification][type] = image

            return {
                ...state,
                photosAdicional
            }
        }

        case ACTIONS_TYPE.REFLEX_DATA_RESPONSE_FIRMA: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.reflexDataFirma = {
                                        assessmentId: action.payload.assessmentId,
                                        coberturas: action.payload.coberturas
                                    }
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.SET_REQUISITOS_INICIALES: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.requisitosIniciales = action.payload.requisitos !== null
                                        && action.payload.requisitos.examenes.length > 0 ? true : false
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.SET_COTIZACIONES: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            if (prospecto.cotizaciones !== undefined && prospecto.cotizaciones !== null
                                && prospecto.cotizaciones.length > 0) {
                                let cotizaciones = action.payload.cotizaciones
                                let cotizacionesSalida = []
                                cotizaciones.map(cotizacion => {
                                    let cotizacionPros = prospecto.cotizaciones.filter(cotizacionAux => cotizacionAux.codigoCotizacion.toString() === cotizacion.codigoCotizacion.toString())[0]
                                    if (cotizacionPros !== undefined) {
                                        cotizacionesSalida.push({
                                            ...cotizacionPros,
                                            codigoEstado: cotizacion.codigoEstado,
                                            idSolicitudMultiple: cotizacion.idSolicitudMultiple
                                        })
                                    } else {
                                        cotizacionesSalida.push(cotizacion)
                                    }
                                    return cotizacion
                                })
                                prospecto.cotizaciones = cotizacionesSalida
                            } else {
                                prospecto.cotizaciones = action.payload.cotizaciones
                            }
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.SET_DATOS_INICIALES_COTIZACION: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.codigoCotizacion.toString() === action.payload.codigoCotizacion.toString()) {
                                    cotizacion.esDistintoAsegurado = action.payload.esDistintoAsegurado
                                    cotizacion.esAPFamiliar = action.payload.esAPFamiliar
                                    cotizacion.requiereFirmaConyuge = action.payload.requiereFirmaConyuge
                                    cotizacion.requiereIngresoHijos = action.payload.requiereIngresoHijos
                                    cotizacion.productos = action.payload.productos
                                    cotizacion.isSelected = true

                                    //Lista Menu
                                    cotizacion.inicioFlujo = true
                                    cotizacion.completado = false
                                    cotizacion.lpdp = null
                                    cotizacion.edicionInhabilitada = false
                                    cotizacion.firmaValidada = false

                                    if (cotizacion.listaMenu === undefined || cotizacion.listaMenu === null
                                        || cotizacion.listaMenu.length === 0) {
                                        cotizacion.listaMenu = GLOBALES.LISTA_MENU_INICIAL
                                    }
                                } else {
                                    cotizacion.isSelected = false
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.SET_CONTRATANTE_COTIZACION: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    let contratante = null
                                    if (action.payload.contratante !== undefined && action.payload.contratante !== null) {
                                        contratante = {
                                            nombres: action.payload.contratante.nombres,
                                            apellidoPaterno: action.payload.contratante.apellidoPaterno,
                                            apellidoMaterno: action.payload.contratante.apellidoMaterno,
                                            tipoDocumento: action.payload.contratante.tipoDocumento,
                                            numeroDocumento: action.payload.contratante.numeroDocumento,
                                            contacto: {
                                                celular: action.payload.contratante.contacto.celular,
                                                email: action.payload.contratante.contacto.email
                                            },
                                            idContratante: action.payload.contratante.idContratante,
                                            fechaNacimiento: action.payload.contratante.fechaNacimiento !== null && 
                                                action.payload.contratante.fechaNacimiento !== undefined
                                                ? Funciones.formatearTextoAFecha(action.payload.contratante.fechaNacimiento)
                                                : null
                                        }
                                    } else {
                                        contratante = action.payload.contratante
                                    }
                                    cotizacion.contratante = contratante
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })
                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.SET_TABLAS_MAESTRAS: {
            let datosMaestros = []
            let arrayCodTablasMaestras = process.env.REACT_APP_SD_WEB_TABLAS_MAESTRAS.split(',')

            for (const codTablaMaestra of arrayCodTablasMaestras) {
                let datos = action.payload.tablasMaestras.filter(tMaestro => tMaestro.idTabla === parseInt(codTablaMaestra))
                let codigo
                let registros = []
                let final
                let descripcion
                datos.forEach(element => {
                    let p = { id: element.id, valor: element.valor }
                    registros.push(p)
                    codigo = element.idTabla
                    descripcion = element.tabla
                })
                final = {
                    codigoMaestro: codigo,
                    descripcion: descripcion,
                    registros: registros
                }

                datosMaestros.push(final)

            }

            localStorage.setItem("tablasMaestrasSD", JSON.stringify(datosMaestros))
            return {
                ...state,
                tablasMaestras: datosMaestros
            }
        }

        case ACTIONS_TYPE.SET_PARAMETROS: {
            let parametros = action.payload.parametros
            localStorage.setItem("parametrosSD", JSON.stringify(parametros))
            return {
                ...state,
                parametros
            }
        }

        case ACTIONS_TYPE.AGREGAR_TABLA_MAESTRA: {
            let tablasMaestras = localStorage.getItem('tablasMaestrasSD') !== undefined
                ? JSON.parse(localStorage.getItem('tablasMaestrasSD') || null)
                : null

            let tablaMaestraEncontrada = false
            tablasMaestras = tablasMaestras && tablasMaestras.map(tablaMaestra => {
                if (tablaMaestra.codigoMaestro === action.payload.codigo) {
                    tablaMaestraEncontrada = true
                    return {
                        codigoMaestro: action.payload.codigo,
                        descripcion: action.payload.descripcion,
                        registros: action.payload.registros
                    }
                }
                return tablaMaestra
            })

            if (!tablaMaestraEncontrada) {
                tablasMaestras && tablasMaestras.push({
                    codigoMaestro: action.payload.codigo,
                    descripcion: action.payload.descripcion,
                    registros: action.payload.registros
                })
            }

            localStorage.setItem('tablasMaestrasSD', JSON.stringify(tablasMaestras))

            return {
                ...state,
                tablasMaestras
            }
        }

        case ACTIONS_TYPE.UPDATE_CORREO_CONTRATANTE: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    if(cotizacion.contratante !== undefined) {
                                        cotizacion.contratante = {
                                            ...cotizacion.contratante,
                                            contacto: {
                                                ...cotizacion.contratante.contacto,
                                                email: action.payload.correo
                                            }
                                        }
                                    } else {
                                        cotizacion.contratante = {
                                            ...cotizacion.contratante,
                                            contacto: {
                                                email: action.payload.correo
                                            }
                                        }
                                    }
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.UPDATE_CORREO_ASEGURADO: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.asegurado = {
                                        ...cotizacion.asegurado,
                                        contacto: {
                                            ...cotizacion.asegurado.contacto,
                                            email: action.payload.correo
                                        }
                                    }
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.SET_BENEFICIARIOS: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.beneficiarios = action.payload.beneficiarios
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.SET_PAGO_RECURRENTE: {
            let solicitudes = null
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    solicitudes = cotizacion.solicitudes.map(solicitud => {
                                        action.payload.pagos.map(pago => {
                                            if (solicitud.idSolicitud === pago.idSolicitud) {
                                                solicitud.cobranza = pago.codigoTipoCobranza
                                            }
                                            return pago
                                        })
                                        return solicitud
                                    })
                                    cotizacion.solicitudes = solicitudes
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.SET_CODIGO_AGENCIA: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.codigoAgencia = action.payload.codigo
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.UPDATE_REEMPLAZO_FIELD: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    let listaDetalleReemplazo = cotizacion.listaDetalleReemplazo
                                    if(listaDetalleReemplazo !== undefined && listaDetalleReemplazo !== null &&
                                        listaDetalleReemplazo.length > 0) {
                                            if(action.payload.indice <= listaDetalleReemplazo.length - 1) {
                                                if(listaDetalleReemplazo[action.payload.indice] !== null) {
                                                    listaDetalleReemplazo[action.payload.indice] = {
                                                        ...listaDetalleReemplazo[action.payload.indice],
                                                        [action.payload.campo]: action.payload.valor
                                                    }
                                                } else {
                                                    listaDetalleReemplazo[action.payload.indice] = {
                                                        [action.payload.campo]: action.payload.valor
                                                    }
                                                }
                                            } else {
                                                listaDetalleReemplazo.push({
                                                    [action.payload.campo]: action.payload.valor
                                                })
                                            }
                                    } else {
                                        listaDetalleReemplazo = [{
                                            [action.payload.campo]: action.payload.valor
                                        }]
                                    }
                                    cotizacion.listaDetalleReemplazo = listaDetalleReemplazo
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.CLEAN_ASEGURADO_FIELD: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.listaDetalleReemplazo = action.payload.valor
                                    cotizacion.preguntas.map(pregunta => {
                                        if ((pregunta.idBancoPregunta === 3 || pregunta.idBancoPregunta === 44) && action.payload.noTiene) {
                                            pregunta.respuestaRapida = 0
                                        } else {
                                            pregunta.respuestaRapida = -1
                                        }
                                        return pregunta
                                    })
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.DELETE_DETALLE_REEMPLAZO: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    let newDetalle = cotizacion.listaDetalleReemplazo.filter(det => det.idSolicitud === action.payload.idSolicitud)
                                    cotizacion.listaDetalleReemplazo = newDetalle
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.ADD_PAGO_CONTADOR: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    //cotizacion.contadorPago = newDetalle
                                    if(cotizacion.contadorPago !== undefined) {
                                        let contadorEncontrado = false
                                        let contadoresPago = cotizacion.contadorPago.map((contadorPago, index) => {
                                            if(contadorPago.codMoneda === action.payload.codMoneda) {
                                                contadorEncontrado = true
                                                contadorPago.contador++
                                            }
                                            return contadorPago
                                        })
                                        if(!contadorEncontrado) {
                                            contadoresPago.push({
                                                codMoneda: action.payload.codMoneda,
                                                contador: 1
                                            })
                                        }
                                        cotizacion.contadorPago = contadoresPago
                                    } else {
                                        cotizacion.contadorPago = [{
                                            codMoneda: action.payload.codMoneda,
                                            contador: 1
                                        }]
                                    }
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.UPDATE_RESPUESTA_RAPIDA: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.preguntas.map(pregunta => {
                                        if (pregunta.idBancoPregunta === 3 || pregunta.idBancoPregunta === 44) {
                                            pregunta.respuestaRapida = action.payload.valor
                                        } else {
                                            pregunta.respuestaRapida = -1
                                        }
                                        return pregunta
                                    })
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.UPDATE_SOLICITUD: {
            let solicitudes = null
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    solicitudes = cotizacion.solicitudes.map(solicitud => {
                                        if (solicitud.idSolicitud === action.payload.solicitud.solicitud.idSolicitud) {
                                            solicitud.codigoEntidadEndoso = action.payload.solicitud.solicitud.codigoEntidadEndoso
                                            solicitud.codigoTipoCreditoEndoso = action.payload.solicitud.solicitud.codigoTipoCreditoEndoso
                                        }
                                        return solicitud
                                    })
                                    cotizacion.solicitudes = solicitudes
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.UPDATE_REEMPLAZO_FIELD_ADICIONAL: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    let listaDetalleReemplazoAdicional = cotizacion.listaDetalleReemplazoAdicional
                                    if(listaDetalleReemplazoAdicional !== undefined && listaDetalleReemplazoAdicional !== null &&
                                        listaDetalleReemplazoAdicional.length > 0) {
                                            if(action.payload.indice <= listaDetalleReemplazoAdicional.length - 1) {
                                                if(listaDetalleReemplazoAdicional[action.payload.indice] !== null) {
                                                    listaDetalleReemplazoAdicional[action.payload.indice] = {
                                                        ...listaDetalleReemplazoAdicional[action.payload.indice],
                                                        [action.payload.campo]: action.payload.valor
                                                    }
                                                } else {
                                                    listaDetalleReemplazoAdicional[action.payload.indice] = {
                                                        [action.payload.campo]: action.payload.valor
                                                    }
                                                }
                                            } else {
                                                listaDetalleReemplazoAdicional.push({
                                                    [action.payload.campo]: action.payload.valor
                                                })
                                            }
                                    } else {
                                        listaDetalleReemplazoAdicional = [{
                                            [action.payload.campo]: action.payload.valor
                                        }]
                                    }
                                    cotizacion.listaDetalleReemplazoAdicional = listaDetalleReemplazoAdicional
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.CLEAN_ASEGURADO_FIELD_ADICIONAL: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    cotizacion.listaDetalleReemplazoAdicional = action.payload.valor
                                    cotizacion.preguntasAdicional.map(pregunta => {
                                        if ((pregunta.idBancoPregunta === 3 || pregunta.idBancoPregunta === 44) && action.payload.noTiene) {
                                            pregunta.respuestaRapida = 0
                                        } else {
                                            pregunta.respuestaRapida = -1
                                        }
                                        return pregunta
                                    })
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }

        case ACTIONS_TYPE.DELETE_DETALLE_REEMPLAZO_ADICIONAL: {
            users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
            users && users.map(user => {
                if (user.isAuthenticated) {
                    user.listaProspectos.map(prospecto => {
                        if (prospecto.isSelected) {
                            prospecto.cotizaciones.map(cotizacion => {
                                if (cotizacion.isSelected) {
                                    let newDetalle = cotizacion.listaDetalleReemplazoAdicional.filter(det => det.idSolicitud === action.payload.idSolicitud)
                                    cotizacion.listaDetalleReemplazoAdicional = newDetalle
                                }
                                return cotizacion
                            })
                        }
                        return prospecto
                    })

                }
                return user
            })

            localStorage.setItem("usersSD", JSON.stringify(users))

            return {
                ...state,
                users
            }
        }


        default:
            return state;
    }
}